export default __webpack_public_path__ + "static/media/mockup-image-02.020c8320.jpg";